import { lazy as lazyLoad } from 'react';

import { route } from './constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    JobProfilesPage: lazyLoad(async () => {
        const { JobProfilesListPage } = await import('./list/JobProfilesListPage');

        return { default: JobProfilesListPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.job-profiles.headline',
        page: lazy.JobProfilesPage,
        path: route.patterns.jobProfiles,
    },
];
